import { render, staticRenderFns } from "./MenuIconButton.vue?vue&type=template&id=2a11630b&scoped=true&"
import script from "./MenuIconButton.vue?vue&type=script&lang=js&"
export * from "./MenuIconButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuIconButton.vue?vue&type=style&index=0&id=2a11630b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11630b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a11630b', component.options)
    } else {
      api.reload('2a11630b', component.options)
    }
    module.hot.accept("./MenuIconButton.vue?vue&type=template&id=2a11630b&scoped=true&", function () {
      api.rerender('2a11630b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/common/utils/components/Buttons/MenuIconButton.vue"
export default component.exports